package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.BoxShadow.Companion.boxShadow
import com.downdogapp.Color.Companion.GREY_BACKGROUND
import com.downdogapp.Display.FLEX
import com.downdogapp.FlexDirection.COLUMN
import com.downdogapp.JustifyContent.SPACE_BETWEEN
import com.downdogapp.Overflow.AUTO
import com.downdogapp.Size.Companion.em
import com.downdogapp.Size.Companion.px
import com.downdogapp.Size.Companion.vh
import com.downdogapp.Size.INHERIT
import com.downdogapp.client.Strings
import com.downdogapp.client.View
import com.downdogapp.client.controllers.HealthWaiverViewController
import com.downdogapp.client.widget.*

actual class HealthWaiverView actual constructor(
  private val controller: HealthWaiverViewController
) : TopLevelView(), View {

  override val root = controllerView {
    bg = background(true)

    fg = foreground(true) {
      centerInParent {
        width = px(600)
        display = FLEX
        flexDirection = COLUMN

        bgColor = GREY_BACKGROUND
        borderRadius = px(10)

        paddingTop = px(50)
        paddingRight = px(35)
        paddingBottom = px(25)
        paddingLeft = px(35)

        boxShadow = boxShadow(px(0), px(5), px(35), px(0), color = Color.black(0.4))

        centerHorizontally {
          label(Strings.HEALTH_DISCLAIMER_AND_WARNING, 21, FontWeight.MEDIUM)
        }

        div {
          marginTop = px(30)
          marginBottom = px(30)
          maxHeight = vh(60)
          overflowY = AUTO

          label(Strings.HEALTH_WAIVER_TEXT, 15) {
            height = INHERIT
            lineHeight = em(1.5)
          }
        }

        horizontalFlexBox(verticalAlign = AlignItems.CENTER, horizontalJustify = SPACE_BETWEEN) {
          div {
            textButton(
              text = Strings.CLOSE,
              fontSize = 21,
              clickFn = controller::onBackClicked
            ) {
              marginLeft = px(30)
            }
          }
          div {
            textButton(
              text = Strings.I_AGREE,
              fontSize = 21,
              clickFn = controller::onAgreeClicked
            ) {
              marginRight = px(30)
            }
          }
        }
      }
    }
  }
}
